import React from 'react';

import { MenuProvider } from 'hooks/menu';
import { ColaboradoresProvider } from 'hooks/contexts/colaboradores';
import { ApontamentoProvider } from 'hooks/contexts/apontamento';
import { LoteProvider } from 'hooks/providers/rastreabilidade/mock';
import ModaisProvider from 'hooks/modais';
import { SelectQuantidadeProvider } from 'components/SelectWithManagement/SelectQualidadeCafe/context/selectQualidade';
import { AuthProvider } from './auth';
import { NotificationsProvider } from './notifications';
import { FavoritesProvider } from './favorites';
import { TabsProvider } from './tabs';
import { DashProvider } from './dashboard';
import { ToastProvider } from './toast';
import { NewToastProvider } from './newToast';
import { PrintProvider } from './PrintHook';
import { CadastrosProvider } from './providers/cadastros/index';
import { ControleProvider } from './providers/controles/index';
import FinanceiroProvider from './providers/financeiro/index';
import RelatoriosProvider from './providers/relatorios';


import { LoginModalProvider } from './contexts/login-modal';

function AppProvider({ children }) {
  return <ToastProvider>
    <LoginModalProvider>
      <NewToastProvider>
        <AuthProvider>
          <NotificationsProvider>
            <FavoritesProvider>
              <MenuProvider>
                <ModaisProvider>
                  <DashProvider>
                    <SelectQuantidadeProvider>
                      <CadastrosProvider>
                        <FinanceiroProvider>
                          <ColaboradoresProvider>
                            <ApontamentoProvider>
                              <ControleProvider>
                                <TabsProvider>
                                  <LoteProvider>
                                    <PrintProvider>
                                      <RelatoriosProvider>
                                        {children}
                                      </RelatoriosProvider>
                                    </PrintProvider>
                                  </LoteProvider>
                                </TabsProvider>
                              </ControleProvider>
                            </ApontamentoProvider>
                          </ColaboradoresProvider>
                        </FinanceiroProvider>
                      </CadastrosProvider>
                    </SelectQuantidadeProvider>
                  </DashProvider>
                </ModaisProvider>
              </MenuProvider>
            </FavoritesProvider>
          </NotificationsProvider>
        </AuthProvider>
      </NewToastProvider>
    </LoginModalProvider>
  </ToastProvider>
}

export default AppProvider;
